import { render, staticRenderFns } from "./AdminStatsCalendar.vue?vue&type=template&id=f623dc44&scoped=true&"
import script from "./AdminStatsCalendar.vue?vue&type=script&lang=js&"
export * from "./AdminStatsCalendar.vue?vue&type=script&lang=js&"
import style0 from "./AdminStatsCalendar.vue?vue&type=style&index=0&id=f623dc44&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f623dc44",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f623dc44')) {
      api.createRecord('f623dc44', component.options)
    } else {
      api.reload('f623dc44', component.options)
    }
    module.hot.accept("./AdminStatsCalendar.vue?vue&type=template&id=f623dc44&scoped=true&", function () {
      api.rerender('f623dc44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/admin/AdminStatsCalendar.vue"
export default component.exports